<ngx-loading-bar [includeBar]="false" [fixed]="false" height="8px" diameter="30px"></ngx-loading-bar>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>